import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "planning-tutorial-msg-2-bottom",
  "use": "planning-tutorial-msg-2-bottom-usage",
  "viewBox": "0 0 68 111",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 111\" id=\"planning-tutorial-msg-2-bottom\"><path fill=\"#C5C5C5\" d=\"m.798 107.973-.155.048-.274-.89-.066-.04 4.91-7.037.82.574-4.16 5.96C44.79 92.744 66.234 57.49 66.234.702h1c0 57.137-21.646 92.776-64.914 106.792l6.53 2.257-.326.948-7.742-2.676.016-.046zm.655-.78.425-.61q-.76.246-1.53.482l.02.066.58.408.16-.46.345.118zm-.655.78q.765-.236 1.52-.48l-.865-.3-.326.466-.178-.128-.155.438z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol